import React from 'react';
import { HelpCircle } from 'lucide-react';
import { Text } from '@cotera/client/app/components/ui';
import type { WorkflowNodeRenderStrategy } from '../types';

export const unknownNodeStrategy: WorkflowNodeRenderStrategy = {
  nodeType: 'unknown',
  accent: 'neutral',
  badge: 'Step',
  getTitle: (node) => node.type,
  getDescription: () => 'Unsupported node type',
  renderIcon: () => <HelpCircle className="h-4 w-4" />,
  renderBody: (node) => (
    <Text.Caption className="text-muted-foreground block">
      No renderer registered for type &quot;{node.type}&quot;.
    </Text.Caption>
  ),
};
